import React from "react";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import "./page-error.scss";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";

const PageError = ({
  title,
  message,
  reloadBtn = false,
  onReloadClick = null,
}) => (
  <div className="errorContainer">
    <PageErrorContent
      title={title}
      message={message}
      reloadBtn={reloadBtn}
      onReloadClick={onReloadClick}
    />
  </div>
);

export const PageErrorContent = ({
  title,
  message,
  reloadBtn,
  onReloadClick = null,
}) => (
  <>
    <div className="errorHeading">{title}</div>
    <div className="errorContent">
      <ErrorOutlineOutlinedIcon className="icon" /> {message}
    </div>
    {reloadBtn && (
      <div className="errorReloadButton">
        <StyledBlueButton
          onClick={() => onReloadClick?.()}
          variant="contained"
          style={{ "margin-right": "10px" }}
        >
          Reload
        </StyledBlueButton>
      </div>
    )}
  </>
);

export default PageError;
